import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
const deliverables = [{
  title: 'La Guía Digital "Fuerza Post-Parto 21"',
  desc: '(PDF descargable)',
  icon: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-140">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" data-id="element-141" />
      </svg>
}, {
  title: 'El Test de Autoevaluación',
  desc: 'Para medir tu diástasis en casa.',
  icon: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-142">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" data-id="element-143" />
      </svg>
}, {
  title: 'El Tutorial Paso a Paso',
  desc: 'Del Vacío Abdominal (Respiración Apneica).',
  icon: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-144">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" data-id="element-145" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-146" />
      </svg>
}, {
  title: 'El Plan de 21 Días',
  desc: 'Con posturas progresivas para cada semana.',
  icon: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-147">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-148" />
      </svg>
}, {
  title: 'Protocolo "Cierre de Seguridad"',
  desc: 'Para cargar a tu bebé sin dañarte.',
  icon: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-149">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-150" />
      </svg>
}, {
  title: 'Manual de soluciones',
  desc: 'Para estornudos y esfuerzos cotidianos.',
  icon: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-151">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-152" />
      </svg>
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function WhatYouGetSection() {
  return <section className="py-12 md:py-24 bg-cream" data-id="element-153">
      <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-154">
        <div className="text-center mb-8 md:mb-16" data-id="element-155">
          <h2 className="text-2xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-156">
            Lo que obtienes hoy
          </h2>
          <div className="w-24 h-px bg-rosegold mx-auto" data-id="element-157"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-30px'
      }} className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-158">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-4 md:p-8 rounded-xl shadow-sm border border-rosegold/10 text-center" data-id="element-159">
              <div className="text-rosegold flex justify-center mb-3 md:mb-6" data-id="element-160">
                {item.icon}
              </div>
              <h3 className="text-sm md:text-xl font-serif text-charcoal mb-1 md:mb-2" data-id="element-161">
                {item.title}
              </h3>
              <p className="text-charcoal/70 text-xs md:text-base" data-id="element-162">
                {item.desc}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div id="oferta" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-10 md:mt-16 bg-charcoal text-cream rounded-2xl p-8 md:p-14 text-center relative overflow-hidden" data-id="element-163">
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-164">
            <div className="absolute -top-48 -right-48 w-96 h-96 rounded-full border-2 border-rosegold" data-id="element-165"></div>
            <div className="absolute -bottom-48 -left-48 w-96 h-96 rounded-full border-2 border-rosegold" data-id="element-166"></div>
          </div>

          <div className="relative z-10" data-id="element-167">
            <h3 className="text-2xl md:text-4xl font-serif mb-4 md:mb-6 leading-tight" data-id="element-168">
              Recupera el control de tu cuerpo hoy mismo por menos de lo que
              cuesta una salida a almorzar.
            </h3>
            <p className="text-base md:text-lg text-cream/80 mb-6 md:mb-10 max-w-2xl mx-auto" data-id="element-169">
              No permitas que un problema funcional se convierta en una lesión
              crónica.
            </p>

            <div className="bg-white/5 backdrop-blur-sm border border-rosegold/30 rounded-2xl p-5 md:p-10 mb-6 md:mb-10 inline-block w-full max-w-md" data-id="element-170">
              <p className="text-rosegold uppercase tracking-widest text-xs md:text-sm mb-2 md:mb-3" data-id="element-171">
                Inversión única
              </p>
              <p className="text-cream/50 line-through text-lg md:text-2xl mb-1" data-id="element-172">
                $19.49 USD
              </p>
              <p className="text-4xl md:text-6xl font-serif mb-1" data-id="element-173">
                $9.99{' '}
                <span className="text-xl md:text-2xl text-cream/60" data-id="element-174">USD</span>
              </p>
            </div>

            <div className="relative mb-6 md:mb-8 mx-auto w-40 md:w-56" data-id="element-175">
              <div className="absolute inset-0 bg-rosegold/10 rounded-full blur-3xl opacity-60 transform scale-125" data-id="element-176"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3ABnAPTvWwTkG6Mg4JrosT/Ps-mk.png" alt="Fuerza Post-Parto 21 Guide" loading="lazy" decoding="async" className="relative z-10 w-full drop-shadow-2xl rounded-lg" data-id="element-177" />
            </div>

            <div data-id="element-178">
              <CTAButton href="https://rutinasimple.com//cart/52288286064921:1" onBeforeNavigate={trackAddToCart} className="w-full md:w-auto text-base md:text-lg py-4 md:py-5 px-8 md:px-10 mb-4 md:mb-6" data-id="element-179">
                ¡SÍ, QUIERO RECUPERAR MI FUERZA!
              </CTAButton>
              <p className="text-cream/60 text-xs md:text-sm flex items-center justify-center" data-id="element-180">
                <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-181">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-182" />
                </svg>
                Acceso inmediato tras la compra.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}